export default "__VITE_ASSET__DXDpAiJR__"